module.exports = __webpack_public_path__ + "static/media/packge_mobix.39db7eb1.jpg";